import { render } from "./freezeLoading.vue?vue&type=template&id=5ea08b38&scoped=true"
import script from "./freezeLoading.vue?vue&type=script&lang=js"
export * from "./freezeLoading.vue?vue&type=script&lang=js"

import "./freezeLoading.vue?vue&type=style&index=0&id=5ea08b38&scoped=true&lang=css"

import exportComponent from "/home/node/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea08b38"]])

export default __exports__